import store from '../../../store';

// Aanmaken van een nieuwe class genaamd Betonpoer
export default class Betonpoer {
  constructor(THREE, betonpoerConfig, fundering) {
    this.THREE = THREE,
    this.lengte = betonpoerConfig.z,
    this.breedte = betonpoerConfig.z,  
    this.hoogte = betonpoerConfig.y,
    this.kleurBetonPoer = { color: 0x242323 },
    this.fundering = fundering
    this.betonPoer = null,
    // console.log(betonpoerConfig);
    this.buildBetonPoer(this.THREE, this.breedte, this.lengte, this.hoogte, this.kleurBetonPoer, fundering)
  }

  // Opbouw van de geometrie van een betonpoer  
  buildBetonPoer(THREE, lengte, breedte, hoogte, kleurBetonPoer, fundering) {
    const geometrie = new THREE.BoxGeometry(lengte, breedte, hoogte);
    const material = new THREE.MeshStandardMaterial(kleurBetonPoer);
    const Poer = new THREE.Mesh(geometrie, material);
    Poer.name = store.getters.getModelMeshNames.poer
    Poer.visible = fundering
    Poer.castShadow = true; 
    Poer.receiveShadow = true;
    this.betonPoer = Poer;
    // this.betonPoerBinnen = this.betonPoer.clone()
    // this.betonPoerBinnen.scale.multiplyScalar(0.999)
    // this.betonPoerBinnen.geometry = this.betonPoerBinnen.geometry.clone()
    // flipGeometryFaces(this.betonPoerBinnen.geometry)
    // this.betonPoerBinnen.material = new THREE.MeshBasicMaterial({color: 0x3abff0, /*side: THREE.BackSide*/});
    // this.betonPoer.add(this.betonPoerBinnen)
    this.betonPoerBinnen = new THREE.Mesh(
      new THREE.PlaneGeometry(1, 1),
      new THREE.MeshBasicMaterial({ color: 0x3abff0 })
    )
    this.betonPoerBinnen.name = store.getters.getModelMeshNames.poerenplan
    this.betonPoerBinnen.rotation.x = -Math.PI
    this.betonPoerBinnen.scale.set(lengte, breedte, 1)
    this.betonPoerBinnen.position.z = hoogte/2 - 10
    this.betonPoer.add(this.betonPoerBinnen)
  }

  updateBetonPoer(betonpoerConfig) {
    // console.log(betonpoerConfig)
    this.lengte = betonpoerConfig.z,
    this.breedte = betonpoerConfig.z,
    this.hoogte = betonpoerConfig.y,
    // console.log(new this.THREE.BoxGeometry(this.lengte, this.breedte, this.hoogte).attributes.position.array)
    this.betonPoer.geometry.attributes.position.array = new this.THREE.BoxGeometry(this.lengte, this.breedte, this.hoogte).attributes.position.array
    this.betonPoer.geometry.attributes.position.needsUpdate = true
    this.betonPoer.geometry.attributes.uv.array = new this.THREE.BoxGeometry(this.lengte, this.breedte, this.hoogte).attributes.uv.array
    this.betonPoer.geometry.attributes.uv.needsUpdate = true
    // this.betonPoerBinnen.geometry.attributes.position.array = new this.THREE.BoxGeometry(this.lengte, this.breedte, this.hoogte).attributes.position.array
    // this.betonPoerBinnen.geometry.attributes.position.needsUpdate = true
    // this.betonPoerBinnen.geometry.attributes.uv.array = new this.THREE.BoxGeometry(this.lengte, this.breedte, this.hoogte).attributes.uv.array
    // this.betonPoerBinnen.geometry.attributes.uv.needsUpdate = true
    // flipGeometryFaces(this.betonPoer.geometry)
    this.betonPoerBinnen.scale.set(this.lengte, this.breedte, 1)
    this.betonPoerBinnen.position.z = this.hoogte/2 - 10
  }

  // Functie om een betonPoer zichtbaar te maken
  betonPoerShow() {
    this.betonPoer.visible = true
  } 

  // Functie om een betonPoer niet zichtbaar te maken
  betonPoerHide() {
    this.betonPoer.visible = false
  }
}

// function flipGeometryFaces(geometry) {
//   // Flip normals
//   const normals = geometry.attributes.normal;
//   if (normals) {
//     for (let i = 0; i < normals.count; i++) {
//       normals.setX(i, -normals.getX(i));
//       normals.setY(i, -normals.getY(i));
//       normals.setZ(i, -normals.getZ(i));
//     }
//     normals.needsUpdate = true;
//   }

//   // Flip triangle winding order
//   if (geometry.index) {
//     const index = geometry.index.array;
//     for (let i = 0; i < index.length; i += 3) {
//       // Swap second and third vertex to reverse the triangle
//       const tmp = index[i + 1];
//       index[i + 1] = index[i + 2];
//       index[i + 2] = tmp;
//     }
//     geometry.index.needsUpdate = true;
//   } else {
//     // Non-indexed geometry → swap positions directly
//     const positions = geometry.attributes.position;
//     const vertex = [];

//     for (let i = 0; i < positions.count; i += 3) {
//       // Swap v1 ↔︎ v2
//       for (let axis = 0; axis < 3; axis++) {
//         const a = positions.getX(i + 1 + axis);
//         const b = positions.getX(i + 2 + axis);
//         positions.setX(i + 1 + axis, b);
//         positions.setX(i + 2 + axis, a);
//       }
//     }

//     positions.needsUpdate = true;
//   }

//   // Ensure vertex normals regenerate properly if needed
//   geometry.computeVertexNormals();
// }